import { render } from "./TraineeDetail.vue?vue&type=template&id=1e8966c2&scoped=true"
import script from "./TraineeDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./TraineeDetail.vue?vue&type=script&setup=true&lang=js"

import "./TraineeDetail.vue?vue&type=style&index=0&id=1e8966c2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8966c2"],['__file',"src/views/course/TraineeDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e8966c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e8966c2', __exports__)) {
    api.reload('1e8966c2', __exports__)
  }
  
  module.hot.accept("./TraineeDetail.vue?vue&type=template&id=1e8966c2&scoped=true", () => {
    api.rerender('1e8966c2', render)
  })

}


export default __exports__